import PropTypes from 'prop-types';

/**
 * PropTypes and defaultProps for AccountUniversalWrapper.
 * List out all supported spacing props for clarity and maintainability.
 */
export const accountUniversalWrapperPropTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  // Base and per-side spacing props
  padding: PropTypes.string,
  margin: PropTypes.string,
  paddingTop: PropTypes.string,
  paddingRight: PropTypes.string,
  paddingBottom: PropTypes.string,
  paddingLeft: PropTypes.string,
  marginTop: PropTypes.string,
  marginRight: PropTypes.string,
  marginBottom: PropTypes.string,
  marginLeft: PropTypes.string,
  // Responsive spacing props
  paddingMd: PropTypes.string,
  paddingLg: PropTypes.string,
  marginMd: PropTypes.string,
  marginLg: PropTypes.string,
};

export const accountUniversalWrapperDefaultProps = {
  className: '',
};
